import React from "react";
import Marquee from "react-fast-marquee";
import { Cog } from "lucide-react";
import { useLanguage } from "../i18n";

export default function DeptMarquee() {
  const { t } = useLanguage();
  const items = t("marquee").split(",");

  return (
    <div data-testid="dept-marquee" className="border-y border-brand-yellow/20 bg-brand-yellow py-4 overflow-hidden">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 whitespace-nowrap">
            <span className="font-display text-lg md:text-xl font-bold uppercase tracking-[0.15em] text-brand-black">
              {item}
            </span>
            <Cog className="h-5 w-5 text-brand-black/60 animate-spin-slow" strokeWidth={1.5} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
